import _ from "lodash";

export const isValidPredicate = value => {
  if (_.isArrayLike(value)) {
    return !_.isEmpty(value);
  }
  return !_.isNil(value);
};
